import React, { Component } from 'react'
import { Link } from 'react-router-dom'
import {reduxForm, Field} from 'redux-form'
import { Row, Col } from 'react-bootstrap'
import InputSelect from '../comun/form/InputSelect'
import InputCheckBox from '../comun/form/InputCheckBox'
import { DoneAll, Refresh, Delete, Launch, Print, AddCircleOutline, FilterList } from '@material-ui/icons'
import {permisos as permisosConstant} from '../../constants/permisos'

class FiltrosTransporte extends Component {
   constructor () {
    super()
    this.state = {
      openFiltros: false,
      imputSelected: false,
      fitrosSeleccionados: []
    }
  }

  fetchFiltrarTransporte(values){
    this.props.actions.filtrarTransporte(values)
  }

  componentDidMount () {
    this.props.actions.comboEmpresaTransportista()
    this.props.actions.comboConductoresTransportista()
    this.props.actions.comboVehiculosTransportista()
    this.props.actions.comboRuta()
    this.props.change('activo', {value: true, label: this.props.t('ESTADO.ACTIVO')})
  }

  componentDidUpdate (prevProps) {
    if (this.props.datosExcelTransporte !== prevProps.datosExcelTransporte) {
      if (this.props.datosExcelTransporte.excel && this.props.datosExcelTransporte.excel !== null){
        let pdf = this.props.datosExcelTransporte.excel
        let element = document.createElement('a')
        // element.setAttribute('href', 'data:application/pdf;base64,' + encodeURIComponent(pdf))
        element.setAttribute('href', 'data:application/vnd.ms-excel;base64,' + encodeURIComponent(pdf))
        element.setAttribute('download', this.props.t('MENU.MANTENIMIENTO_DATOS.TRANSPORTE.TRANSPORTISTAS') + ".xlsx")
        element.style.display = 'none'
        document.body.appendChild(element)
        element.click()
        document.body.removeChild(element)
      }
    }
    if (this.props.datosPdfTransporte !== prevProps.datosPdfTransporte) {
      if (this.props.datosPdfTransporte.pdf && this.props.datosPdfTransporte.pdf !== null){
        let pdf = this.props.datosPdfTransporte.pdf
        let element = document.createElement('a')
        element.setAttribute('href', 'data:application/pdf;base64,' + encodeURIComponent(pdf))
        element.setAttribute('download', this.props.t('MENU.MANTENIMIENTO_DATOS.TRANSPORTE.TRANSPORTISTAS') + ".pdf")
        element.style.display = 'none'
        document.body.appendChild(element)
        element.click()
        document.body.removeChild(element)
      }
    }
    if (this.props.formSimpleTable && Object.keys(this.props.formSimpleTable).length > 0) {
      if (this.props.formSimpleTable !== prevProps.formSimpleTable) {
        let contActivos = 0
        if (this.props.formSimpleTable.values) {
          Object.values(this.props.formSimpleTable.values).forEach((value) => {
            if (value === true) {
              contActivos++
            }
          })
          if (contActivos === 0) {
            this.props.change('seleccionar-todo', false)
            this.setState({ imputSelected: false })
            this.props.actions.deSeleccionarTodosTransporte()
          }
        }
      }
    }
  }

  abrirFiltros = (event) => {
    this.setState({ openFiltros: true })
  }

  cerrarFiltros = (event) => {
    this.setState({ openFiltros: false })
  }

  intercambiarCheck = (value) => {
    this.setState({ imputSelected: value })
    if (value === true) {
      this.props.actions.seleccionarTodosTransporte()
    } else {
      this.props.actions.deSeleccionarTodosTransporte()
    }
  }

  deleteSeleccionTransporte(){
    const itemsSeleccion = this.props.list.map((row) => {
      return this.props.formSimpleTable.values['check' + row.idElemento] === true && (
        {
          'check': this.props.formSimpleTable.values['check' + row.idElemento],
          'idTransportista': row.idTransportista,
          'activo': row.activo,
          'cifTransportista': row.cifTransportista,
          'conductorTransporte': row.conductorTransporte,
          'nombreRuta': row.nombreRuta,
          'nombreTransportista': row.nombreTransportista,
          'vehiculoTransporte': row.vehiculoTransporte
        }
      )
    })

    let list = itemsSeleccion.filter(function (item) {
      return item.check === true;
    });
    this.props.actions.deleteSeleccionTransporte(list)
  }

  cambioEstadoSeleccionTransporte(){
    const itemsSeleccion = this.props.list.map((row) => {
      return this.props.formSimpleTable.values['check' + row.idElemento] === true && (
        {
          'check': this.props.formSimpleTable.values['check' + row.idElemento],
          'idTransportista': row.idTransportista,
          'activo': row.activo,
          'cifTransportista': row.cifTransportista,
          'conductorTransporte': row.conductorTransporte,
          'nombreRuta': row.nombreRuta,
          'nombreTransportista': row.nombreTransportista,
          'vehiculoTransporte': row.vehiculoTransporte
        }
      )
    })

    let list = itemsSeleccion.filter(function (item) {
      return item.check === true;
    });
    this.props.actions.cambioEstadoSeleccionTransporte(list)
    this.props.change('seleccionar-todo', false)
  }

  crearCsvTransporte(){
    this.props.actions.crearCsvTransporte(this.props.filtros)
  }

  imprimirPdfTransporte () {
    this.props.actions.imprimirPdfTransporte(this.props.filtros)
  }

  quitarFiltros (value) {
    let values = this.props.filtros
    values[value] = null
    this.props.actions.filtrarTransporte(values)
    this.props.change(value, null)
    this.setState({fitrosSeleccionados: values})
  }

  render () {
  const {
    t, handleSubmit, filtros,
    actions: {
      abrirModalVacioTransporte
    },
    auth: { permisos },
    combos: {
      comboTransporte, comboCliente, comboEmpresaTransportista, comboConductoresTransportista, comboVehiculosTransportista, comboRuta
    }
  } = this.props

  let comboEstado = this.props.combos.comboEstado
  comboEstado = comboEstado.map((estado) => {
    return {...estado, label: t(estado.label)}
  })

  return (
      <div>
        <div className={this.state.openFiltros === true ? 'tabla-filtros open-filters' : 'tabla-filtros'}>
          <form className="custom-form">
            <Field
              colSm={2}
              id="empresa"
              name="empresa"
              controlLabel={t('TRANSPORTE.FILTROS.EMPRESA')}
              component={InputSelect}
              options={comboEmpresaTransportista}
              valueKey="value"
              labelKey="label"
              customClass='select-empresa'
              onInputChange={handleSubmit(this.fetchFiltrarTransporte.bind(this))}
            />
            <Field
              colSm={2}
              id="conductor"
              name="conductor"
              controlLabel={t('TRANSPORTE.FILTROS.CONDUCTOR')}
              component={InputSelect}
              options={comboConductoresTransportista}
              valueKey="value"
              labelKey="label"
              customClass='select-conductor'
              onInputChange={handleSubmit(this.fetchFiltrarTransporte.bind(this))}
            />
            <Field
              colSm={2}
              id="vehiculo"
              name="vehiculo"
              controlLabel={t('TRANSPORTE.FILTROS.VEHICULO')}
              component={InputSelect}
              options={comboVehiculosTransportista}
              valueKey="value"
              labelKey="label"
              customClass='select-vehiculo'
              onInputChange={handleSubmit(this.fetchFiltrarTransporte.bind(this))}
            />
            <Field
              colSm={2}
              id="ruta"
              name="ruta"
              controlLabel={t('TRANSPORTE.FILTROS.RUTA')}
              component={InputSelect}
              options={comboRuta}
              valueKey="value"
              labelKey="label"
              customClass='select-ruta'
              onInputChange={handleSubmit(this.fetchFiltrarTransporte.bind(this))}
            />
            <Field
              colSm={2}
              id="activo"
              name="activo"
              controlLabel={t('TRANSPORTE.FILTROS.ESTADO')}
              component={InputSelect}
              options={comboEstado}
              valueKey="value"
              labelKey="label"
              customClass='select-estado'
              onInputChange={handleSubmit(this.fetchFiltrarTransporte.bind(this))}
            />
            <div className="aplicar-tabla-filtros">
              <div className="filtros-anadidos">
                {
                  Object.keys(filtros).length > 0 && (
                    filtros.empresa && filtros.empresa !== null && (
                      <span className="badge-dark">{t('TRANSPORTE.FILTROS.EMPRESA') + ': ' + filtros.empresa.label}<button type="button" className="quitar-filtro" onClick={() => this.quitarFiltros('empresa')}> x </button></span>
                    )
                  )
                }
                {
                  Object.keys(filtros).length > 0 && (
                    filtros.conductor && filtros.conductor !== null && (
                      <span className="badge-dark">{t('TRANSPORTE.FILTROS.CONDUCTOR') + ': ' + filtros.conductor.label}<button type="button" className="quitar-filtro" onClick={() => this.quitarFiltros('conductor')}> x </button></span>
                    )
                  )
                }
                {
                  Object.keys(filtros).length > 0 && (
                    filtros.vehiculo && filtros.vehiculo !== null && (
                      <span className="badge-dark">{t('TRANSPORTE.FILTROS.VEHICULO') + ': ' + filtros.vehiculo.label}<button type="button" className="quitar-filtro" onClick={() => this.quitarFiltros('vehiculo')}> x </button></span>
                    )
                  )
                }
                {
                  Object.keys(filtros).length > 0 && (
                    filtros.ruta && filtros.ruta !== null && (
                      <span className="badge-dark">{t('TRANSPORTE.FILTROS.RUTA') + ': ' + filtros.ruta.label}<button type="button" className="quitar-filtro" onClick={() => this.quitarFiltros('ruta')}> x </button></span>
                    )
                  )
                }
                {
                  filtros && Object.keys(filtros).length > 0 && (
                    filtros.activo && filtros.activo !== null && (
                      <span className="badge-dark">{t('TRANSPORTE.FILTROS.ESTADO') + ': ' + filtros.activo.label}<button type="button" className="quitar-filtro" onClick={() => this.quitarFiltros('activo')}> x </button></span>
                    )
                  )
                }
              </div>
            </div>
          </form>
        </div>
        <Row className="acciones-tabla-filtros">
          <Col sm={10}>
            <div className="buttons-flex">
              {(permisos === '-1' || permisos[permisosConstant.TRANSPORTISTAS] > 1) && [
                <div className="custom-check-w" key="checkbox_key">
                  <Field
                    id="seleccionar-todo"
                    name="seleccionar-todo"
                    colSm={12}
                    inline
                    component={InputCheckBox}
                    onInputChange={(value) => this.intercambiarCheck(value)}
                  />
                </div>,
                <div id="block-options" key="blockOptions_key" className={this.state.imputSelected === true ? 'button-group buttons-min block-options' : 'button-group buttons-min block-options oculta-action'}>
                  <button type="button" data-toggle="modal" data-target="#cambio-estado" className="btn btn-icono" onClick={(e) => this.cambioEstadoSeleccionTransporte()}>
                    <Refresh></Refresh> {t('TITULOS_BOTONES.CAMBIAR_ESTADO')}
                  </button>
                  <button type="button" data-toggle="modal" data-target="#delete-modal" className="btn btn-icono" onClick={(e) => this.deleteSeleccionTransporte()}>
                    <Delete></Delete> {t('TITULOS_BOTONES.ELIMINAR')}
                  </button>
                   <div className="barra-buttons-min"></div>
              </div>
              ]}
              <div className="button-group buttons-min">
                <button type="button" className="btn btn-icono" onClick={(e) => this.crearCsvTransporte()}>
                  <Launch></Launch> {t('TITULOS_BOTONES.EXPORTAR')}
                </button>
                <button type="button" className="btn btn-icono" onClick={(e) => this.imprimirPdfTransporte()}>
                  <Print></Print> {t('TITULOS_BOTONES.IMPRIMIR')}
                </button>
                {(permisos === '-1' || permisos[permisosConstant.TRANSPORTISTAS] > 1) ? (
                  <Link to="/NuevoTransportista" className="btn btn-primary nuevo" style={{verticalAlign: 'top', marginTop: '1px'}}>
                    <AddCircleOutline></AddCircleOutline> {t('TITULOS_BOTONES.NUEVO')}
                  </Link>
                ) : (
                  <button
                    type="button"
                    className="btn btn-primary nuevo disabled"
                    disabled={true}
                  >{t('TITULOS_BOTONES.NUEVO')}</button>
                )}
              </div>
            </div>
          </Col>
          <Col sm={2} className="content-button-filtro">
            <div className="button-group buttons-min button-filtro">
              <div className={this.state.openFiltros === true ? 'btn filters-desp opener-open' : 'btn filters-desp'} onClick={(e) => this.state.openFiltros === false ? this.abrirFiltros() : this.cerrarFiltros()}>
                <FilterList></FilterList> {t('TITULOS_BOTONES.FILTROS')}
              </div>
            </div>
          </Col>
        </Row>
      </div>
    )
  }
}

export default (reduxForm({
  form: 'filtrosTransporte',
  enableReinitialize: true
})(FiltrosTransporte))
